/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const Online = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M20.0941,4.9524A1,1,0,0,0,19.095,4H16.0486a4,4,0,1,0-8,0H4.9053a1,1,0,0,0-.999.9524l-.9048,19A1,1,0,0,0,4,25H20a1,1,0,0,0,.999-1.0476ZM12.0486,1a3.0034,3.0034,0,0,1,3,3h-6A3.0034,3.0034,0,0,1,12.0486,1ZM4.9053,5H8.0486V8.5a.5.5,0,0,0,1,0V5h6V8.5a.5.5,0,0,0,1,0V5h3.0349l.7234,15H4.191ZM4,24l.1429-3H19.8551L20,24Z" />
    </BaseSvgIcon>
  )
}

export default Online
